import classes from "./FooterInfo.module.css";
import { INFORMATIONS, SOLCO_INFO } from "../../utils/Const";
import { images } from "../../assets/img";
import useCheckIsMobile from "../../hook/useCheckIsMobile";
import { useEffect, useRef, useState } from "react";

const FACEBOOK_SDK_ID = "facebook-jssdk";

const FooterInfo = (props) => {
  const isMobile = useCheckIsMobile();
  const facebookEmbedRef = useRef(null);
  const [shouldLoadFacebook, setShouldLoadFacebook] = useState(false);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const target = facebookEmbedRef.current;

    if (!target || shouldLoadFacebook) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldLoadFacebook(true);
          observer.disconnect();
        }
      },
      { rootMargin: "250px 0px" }
    );

    observer.observe(target);

    return () => observer.disconnect();
  }, [shouldLoadFacebook]);

  useEffect(() => {
    if (!shouldLoadFacebook) {
      return undefined;
    }

    const parseFacebookWidget = () => {
      if (window.FB?.XFBML?.parse && facebookEmbedRef.current) {
        window.FB.XFBML.parse(facebookEmbedRef.current);
      }
    };

    const existingScript = document.getElementById(FACEBOOK_SDK_ID);

    if (existingScript) {
      parseFacebookWidget();
      return undefined;
    }

    const script = document.createElement("script");
    script.id = FACEBOOK_SDK_ID;
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.src =
      "https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v19.0&appId=213686055057855";
    script.onload = parseFacebookWidget;

    document.body.appendChild(script);

    return undefined;
  }, [shouldLoadFacebook]);

  return (
    <footer className={classes.wrapper}>
      <div className={classes.container}>
        <div className={classes.columnInfo}>
          <div className={classes.address}>
            <h2 className={classes.restaurantName}>{INFORMATIONS.name}</h2>
            <a target={"_blank"} href={INFORMATIONS.ggMapUrl} rel="noreferrer">
              {`40 Terminus Rd, Eastbourne BN21 3LP,${
                isMobile ? "" : "\n"
              }United Kingdom\n\n`}
            </a>
          </div>

          <div className={classes.openingTimeWrapper}>
            <h3>Opening Time</h3>
            <div className={classes.openingTimeContainer}>
              <div className={classes.openingTime}>
                <h3>{"Mon-Thu, Sunday"}</h3>
                <h3>{"11:00 - 15:00 & 16:00 - 20:00"}</h3>
              </div>
              <div className={classes.openingTime}>
                <h3>{"Fri-Sat"}</h3>
                <h3>{"11:00 - 15:00 & 16:00 - 20:30"}</h3>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.contactContainer}>
          <h3>Contact Us</h3>
          <a href={`tel:${INFORMATIONS.tel}`}>{`Hotline: ${INFORMATIONS.phone}\n\n`}</a>
          <a href={`mailto:${INFORMATIONS.email}`}>{`Email: ${INFORMATIONS.email}`}</a>
        </div>

        <div className={classes.columnInfo}>
          <div className={`${classes.contactContainer} ${classes.marginBottom}`}>
            <h3>Follow Us</h3>
            <a target={"_blank"} href={INFORMATIONS.instagram} rel="noreferrer">
              <img alt={"insta"} src={images.instaIcon} />
            </a>
            <a target={"_blank"} href={INFORMATIONS.facebook} rel="noreferrer">
              <img alt={"insta"} src={images.fbIcon} />
            </a>
          </div>

          <br />

          <div ref={facebookEmbedRef} className={classes.facebookWrapper}>
            {shouldLoadFacebook ? (
              <div
                className="fb-page"
                data-href={INFORMATIONS.facebook}
                data-tabs="timeline"
                data-width={isMobile ? "320" : "300"}
                data-height="100"
                data-small-header="false"
                data-adapt-container-width="false"
                data-hide-cover="false"
                data-show-facepile="true"
              >
                <blockquote
                  cite={INFORMATIONS.facebook}
                  className="fb-xfbml-parse-ignore"
                >
                  <a href={INFORMATIONS.facebook}>{INFORMATIONS.name}</a>
                </blockquote>
              </div>
            ) : (
              <a
                href={INFORMATIONS.facebook}
                target="_blank"
                rel="noreferrer"
                className={classes.facebookPlaceholder}
              >
                Load Facebook feed
              </a>
            )}
          </div>
        </div>
      </div>

      <div className={classes.creditFooter}>
        <h4>
          {`Copyright \u00A9 ${currentYear} ${INFORMATIONS.name}. All rights reserved. Designed by `}
          <a target="_blank" href={SOLCO_INFO.website} rel="noreferrer">
            {`SOLCO Marketing`}
          </a>
          {` & `}
          <a
            target="_blank"
            href={SOLCO_INFO.huaCatLuongWebsite}
            rel="noreferrer"
          >
            {`Hua Cat Luong`}
          </a>
        </h4>
      </div>
    </footer>
  );
};

export default FooterInfo;
